import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=3208b444&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports